export const OPERADORES = [
  {
    operador: 'E',
    tooltip:
      'Busca todas as palavras desejadas. Quando nenhum operador é indicado, o "E" é utilizado por padrão. Exemplo: furto E carro E estacionamento',
    value: 'E',
  },
  {
    operador: 'Ou',
    tooltip:
      'Busca alguma(s) ou todas as palavras desejadas. Exemplo: bicicleta OU carro OU motocicleta',
    value: 'Ou',
  },
  {
    operador: 'Não',
    tooltip: 'Busca uma palavra e não outra. Exemplo: corrupção NÃO passiva',
    value: 'Não',
  },
  {
    operador: 'Interrogacao',
    tooltip:
      'Busca palavras com um caractere qualquer substituindo o ?. Exemplo: vici? - vicio, vicia, vicie',
    value: '?',
  },
  {
    operador: 'Asterisco',
    tooltip:
      'Busca palavras com um conjunto qualquer de caracteres substituindo o *. Exemplo: vici* - viciado, viciada, vicioso',
    value: '*',
  },
  {
    operador: 'Aspas',
    tooltip:
      'Busca uma frase completa que esteja entre as aspas. Exemplo: "mandado de segurança"',
    value: '""',
  },
  {
    operador: 'Adj',
    tooltip:
      'Exemplo: furto prox5 estacionamento. Obs: "estacionamento" será no máximo a quinta palavra antes ou após "furto"',
    value: 'Adj',
  },
  {
    operador: 'Prox',
    tooltip:
      'Exemplo: furto adj5 estacionamento. Obs: "estacionamento" será no máximo a quinta palavra após "furto"',
    value: 'Prox',
  },
];
